import React, { useRef } from 'react';
import { Select } from 'new/elements/Select';
import { TextField } from 'new/elements/TextField';
import { ReusableTransformUtil } from 'new/utils/ReusableTransform/argumentValues';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import { AutoSizer } from 'react-virtualized';
import { useGetForm } from 'new/hooks/useGetForm';
import { Form } from 'src/types';
import { FORM_TYPE_CREATE_REUSABLE_TX as FormKey } from 'js/constants/formTypes';
import TransformBuilderPopover from 'new/components/ReusableTransform/ReusableBuilderPreview/TransformBuilderPopover';
import { TransformDataForm, TransformType } from 'new/components/ReusableTransform/types';

import './ReusableBuilderPreview.scss';

const loadableMonacoEditorOptions = { readOnly: true };

export function ReusableBuilderPreview() {
  const editor = useRef(null);
  const form = useGetForm<Form<TransformDataForm>>(FormKey);

  if (!form?.data) return null;

  const isRecordTx = form?.data.transformType === TransformType.RECORD;
  const generatedOutput = form?.data.output;
  const argumentValues = form?.data.txArgs?.items || [];
  const argumentsTestData = form?.data.txArgsTestData || [];

  const generateOutPutStyle = isRecordTx ? { maxHeight: '100%' } : { maxHeight: '50%' };

  return (
    <div className="reusable-builder-preview-component">
      {isRecordTx ? null : (
        <>
          <TransformBuilderPopover />

          <div className="inner-container">
            <div className="preview-content flex-1">
              <ul aria-label="preview-args-list" className="thin-scroll-bar-style">
                {argumentValues.map((value, idx) => {
                  const key = 'preview-args-list-item' + idx;
                  const optionValue = ReusableTransformUtil.getCurrentOptionValue(
                    argumentsTestData,
                    idx,
                  );

                  const {
                    currentValue = ReusableTransformUtil.SELECTION_OPTIONS_TYPE[0].title,
                    currentType = ReusableTransformUtil.SELECTION_OPTIONS_TYPE[0].value,
                  } = optionValue;

                  const inputCurrentValue = currentValue ?? '';

                  return (
                    <li key={key}>
                      <Select
                        disabled
                        label={value.name}
                        value={currentType}
                        items={[{ value: currentType, title: currentType }]}
                      />
                      <TextField value={inputCurrentValue} disabled />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      )}

      <div style={generateOutPutStyle} className="inner-container generated-output flex-1">
        <span className="title">Generated Output</span>
        <div className="content-output">
          <AutoSizer>
            {({ width, height }) => (
              <LoadableMonacoEditor
                ref={editor}
                height={height}
                width={width}
                theme="light"
                language="json"
                value={generatedOutput}
                options={loadableMonacoEditorOptions}
              />
            )}
          </AutoSizer>
        </div>
      </div>
    </div>
  );
}

export default ReusableBuilderPreview;
